import { TypedDocumentNode } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import { GlobalTemplatesQueryDocument } from '@docpace/manager-graphql/dist/urql.types'
import { GlobalTemplatesQueryResultFragment } from '@docpace/manager-graphql'

const typedGlobalTemplatesQueryDocument = GlobalTemplatesQueryDocument as TypedDocumentNode<GlobalTemplatesQueryResultFragment>

export function useGlobalTemplatesQuery(opts?: useQuery.Options<GlobalTemplatesQueryResultFragment>){
    return useQuery(typedGlobalTemplatesQueryDocument, opts)
}
